import { AnimatePresence } from 'framer-motion';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useBookingContext } from '../../../contexts/BookingProvider';
import { AvailableAssociate } from '../../../types/appointments';
import { Client } from '../../../types/users';
import AvailableSlotsModal from '../../CommonComps/Modals/AvailableSlotsModal';
import UpdateClientProfileModal from '../../CommonComps/Modals/UpdateClientProfileModal';

const AppointmentBookingModalWrapper = () => {
  // integration of context hooks here
  const {
    searchDate,
    showAvailableSlotModal,
    showUpdateClientModal,
    setShowAvailableSlotModal,
    setShowUpdateClientModal,
    setShowSuggestionModal,
    selectedAssociate,
    partialTimeSlots,
  } = useBookingContext();
  const { currentUser } = useAuthContext();

  // rendering appointment booking modal wrapper section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showAvailableSlotModal ? (
          <AvailableSlotsModal
            date={searchDate}
            associate={selectedAssociate as AvailableAssociate}
            partialTimeSlots={partialTimeSlots}
            handleModalClose={() => setShowAvailableSlotModal(false)}
            handleAdditionalModalClose={() => setShowSuggestionModal(false)}
          />
        ) : null}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showUpdateClientModal ? (
          <UpdateClientProfileModal
            client={currentUser as Client}
            handleModalClose={() => setShowUpdateClientModal(false)}
          />
        ) : null}
      </AnimatePresence>
    </section>
  );
};

export default AppointmentBookingModalWrapper;
